import React from 'react';

import { i18n } from 'core/localization';
import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { CreateServiceForm } from './createServiceForm';
import { CreateServiceFormStore } from './createServiceFormStore';

export const openCreateServiceForm = () => {
	const store = new CreateServiceFormStore();

	const modal = openModal(
		() => ({
			title: i18n('Create Service'),
			mode: 'create',
			width: 480,
			resizable: false,
			positionType: ModalPosition.Centered,
			mask: { closable: false },
			// the legacy kendo team form is rendered outside the modal and can't get focus while the trap is on
			focusable: { trap: !store.teamFormOpened },
			okButtonProps: { disabled: store.okDisabled, loading: store.saving },
			onOk: async (e) => {
				e.preventDefault();
				const serviceId = await store.save();
				if (serviceId) {
					modal.close(true);
					store.destroy();
					store.openCreatedService(serviceId);
				}
			},
			onCancel: () => {
				store.destroy();
			},
		}),
		<CreateServiceForm store={store} />,
	);

	return modal;
};
